module.exports = __webpack_public_path__ + "img/copper-coin-line.69d4e70a.svg";